import { View } from "@react-pdf/renderer";
import React from "react";
import { tw } from "../tailwind";
import { Text } from "../text";

/** Props Interface */
interface PageNumberProps {
	documentId?: string;
}

export function PageNumber(_: PageNumberProps) {
	/** Render */
	return (
		<React.Fragment>
			<View
				fixed
				style={{
					position: "absolute",
					bottom: 0,
					left: 0,
					right: 0,
					...tw("py-3 flex-row justify-center"),
				}}
				render={({ pageNumber, totalPages }: any) => (
					<View>
						<Text style={tw("text-xs")}>
							{pageNumber} von {totalPages}
						</Text>
					</View>
				)}
			/>
		</React.Fragment>
	);
}
